<template>
  <modal :show.sync="showModal" size="lg">
    <template slot="header">
      <h5 class="modal-title">Vincular Produtos</h5>
    </template>
    <validation-observer ref="form">
      <div class="row">
        <div class="col-md-6">
          <label class="form-control-label">Produto <span class="text-danger">*</span></label>
          <multiselect
            v-model="selectedPreferredProduct"
            :options="selectProductsStructure"
            placeholder="Especifique o Produto"
            track-by="id"
            label="name"
            group-values="products"
            group-label="origin"
            :group-select="false"
            :allow-empty="false"
            :preserveSearch="true"
            :showNoResults="false"
            @input="checkExistingProduct"
            @search-change="updateNewProductName"
          />
          <div
            v-if="!selectedPreferredProduct.name && invalidFields"
            class="invalid-feedback"
            style="display: block;"
          >
            Campo obrigatório
          </div>
        </div>
        <div class="col-md-6">
          <label class="form-control-label">Marca <span class="text-danger">*</span></label>
          <multiselect
            v-model="selectedCommercialBrand"
            :options="selectBrandsStructure"
            group-values="brands"
            group-label="origin"
            placeholder="Especifique a marca"
            :group-select="false"
            :allow-empty="false"
            :preserveSearch="true"
            :showNoResults="false"
            :internal-search="false"
            @input="checkExistingProduct"
            @search-change="updateNewBrandName"
            :loading="isLoadingCommercialBrands"
          />
          <div
            v-if="!selectedCommercialBrand && invalidFields"
            class="invalid-feedback"
            style="display: block;"
          >
            Campo obrigatório
          </div>
        </div>
        <div class="col-md-6 mb-3 mt-2">
          <label class="form-control-label">Filtrar Fornecedor</label>
          <multiselect
            v-model="baseBrand"
            :options="availableBrands"
            placeholder="Selecionar Fornecedor"
            label="name"
            :allow-empty="true"
            track-by="id"
            @input="searchProductsBrand"
          />
        </div>
        <div class="col-md-12">
          <template>
            <vue-list-picker
              :left-items="availableProducts"
              :right-items="selectedProducts"
              :content-key="'id'"
              content-attr="description"
              title-left="Produtos"
              title-right="Produtos Selecionados"
              title-class="group-title"
              button-class="btn btn-success button-class"
              :leftSearch="true"
              @search-action-left="searchProductsName"
              leftSearchPlaceholder="Escolha um produto"
            >
              <template v-slot:tooltip="{ item }">
                <p>{{item.description}} - {{item.code}}</p>
              </template>
            </vue-list-picker>
          </template>
        </div>
        <div class="col-md-6">
          <div slot="footer" class="py-4 justify-content-end base-pagination-css">
            <base-pagination
              v-on:input="changePage"
              v-model="paginatedProductsLeft['current']"
              :total="paginatedProductsLeft['count']"
              :perPage="paginatedProductsLeft['per_page']"
            />
          </div>
        </div>
      </div>
    </validation-observer>
    <template slot="footer">
      <base-button type="secondary" @click="closeModal()">Fechar</base-button>
      <base-button type="success" :disabled="checkingExistingProduct" @click="save">Concluir</base-button>
    </template>
  </modal>
</template>
<script>
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import VueListPicker from "@/components/Vue-list-picker/VueListPicker";

export default {
  name: "grouped-products-modal",
  components: {
    VueListPicker,
    Multiselect,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    commercial: {
      type: Object,
      required: true,
    },
    commercialProduct: {
      type: Object,
    },
    commercialBrand: {
      type: Object,
      required: false,
    },
    editing: {
      type: Boolean,
    }
  },
  data() {
    return {
      invalidFields: false,
      checkingExistingProduct: false,
      selectedCommercialBrand: "",
      selectedPreferredProduct: {},
      selectedProducts: [],
      availableProducts: [],
      preferredproducts: [],
      preferredproductSearchTimeout: null,
      commercialBrands: [],
      selectProductsStructure: [
        {
          origin: "Novo Tipo",
          products: [
            { id: "new", name: "" },
          ],
        },
        {
          origin: "Tipos Existentes",
          products: this.preferredproducts,
        },
      ],
      selectBrandsStructure: [
        {
          origin: "Nova marca",
          brands: [""]
        },
        {
          origin: "Marcas Existentes",
          brands: [],
        },
      ],
      filter: {
        name: null,
        brand_id: null,
      },
      baseBrand: {},
      availableBrands: [],
      paginatedProductsLeft: {},
      nameSearchTimeout: null,
      commercialBrandsTimeout: null,
      isLoadingCommercialBrands: false,
    };
  },
  mounted() {
    this.getPageData()
  },
  methods: {
    setCommercialProductsAttributes() {
      if (!this.commercialProduct) return;
      
      this.selectProductsStructure[0].products[0].name = this.commercialProduct.name;
      this.selectedPreferredProduct = this.selectProductsStructure[0].products[0];
      this.selectBrandsStructure[0].brands[0]  = this.commercialProduct.commercial_brand_name;
      this.selectedCommercialBrand = this.selectBrandsStructure[0].brands[0];
    },
    async getselectedProducts() {
      if (!this.commercialProduct) return;

      const q = { 
        commercial_product_id: this.commercialProduct.id,
        status: 'active' 
      }

      try {
        const response = await this.$http.secured.get(`/api/v1/products`, {
          params: { q: q }
        });

        this.selectedProducts = response.data.products;
      } catch (error) {
        console.log(error);
      }
    },
    async save() {
      if (!this.selectedPreferredProduct.name || !this.selectedCommercialBrand) {
        this.invalidFields = true
        return;
      }

      this.invalidFields = false

      this.saveCommercialProduct();
    },
    async checkExistingProduct() {
      if (this.editing) return;
      if (!this.selectedCommercialBrand || !this.selectedPreferredProduct.name) return;

      try {
        this.checkingExistingProduct = true

        const response = await this.$http.secured.get(`/api/v2/commercial_products`, {
          params: { q: { 
            name: this.selectedPreferredProduct.name.toUpperCase(), commercial_id: this.commercial.id, 
            commercial_brand_name: this.selectedCommercialBrand 
          }}
        });

        const commercialProducts = response.data.data

        if (!commercialProducts.length) {
          this.$emit('update:commercial-product', null)

          return;
        };

        const existingCommercialProduct = commercialProducts[0]

        this.$emit('update:commercial-product', existingCommercialProduct)
        
      } catch (error) {
        console.log(error);
      } finally {
        this.checkingExistingProduct = false
      }
    },
    async saveCommercialProduct() {
      try {
        if (this.commercialProductPostData.id) {
          await this.$http.secured.put(`/api/v2/commercial_products/${this.commercialProductPostData.id}`, this.commercialProductPostData);
        } else  {
          await this.$http.secured.post(`/api/v2/commercial_products`, this.commercialProductPostData);
        }

        this.$toasted.global.defaultSuccess({msg: "Produtos vinculados com sucesso!"});

        this.$emit("submit")
      } catch (error) {
        console.log(error);
      } finally {
        this.closeModal();
      }
    },
    debouncePreferredProducts(name) {
      if (this.preferredproductSearchTimeout) {
        clearTimeout(this.preferredproductSearchTimeout);
      }

      return new Promise((resolve) => {
        this.preferredproductSearchTimeout = setTimeout(async () => {
          await this.getPreferredProducts(1, name);
          resolve();
        }, 500);
      });
    },
    async updateNewProductName(name) {
      await this.debouncePreferredProducts(name);

      this.updateProductStructure(name);
    },
    async getPreferredProducts(page = 1, name = "") {
      const q = {}
      if (name) {
        q.name = name;
      }

      try {
        const response = await this.$http.secured.get(`/api/v2/preferredproducts/`, {
          params: { page: page, q: q }
        });

        this.preferredProducts = response.data.data;
        this.selectProductsStructure[1].products = this.preferredProducts;

      } catch (error) {
        console.log(error);
      }
    },
    async debounceGetBrands(query) {
      if (this.commercialBrandsTimeout) clearTimeout(this.commercialBrandsTimeout);

      return new Promise((resolve) => {
        this.commercialBrandsTimeout = setTimeout(async () => {
          await this.getCommercialBrands(query);
          resolve();
        }, 500);
      });
    },
     async updateNewBrandName(name){
      await this.debounceGetBrands(name)

      this.updateBrandStructure(name)
    },
    getProducts(page = 1) {
      let data = { status: 'active'}
      if (this.filter.name) data['description'] = this.filter.name
      if (this.filter.brand_id) data['brand_id'] = this.filter.brand_id
      if (this.commercialProduct && this.commercialProduct.id) {
        data['not_in_commercial_product'] = this.commercialProduct.id
      }

      return this.$http.secured
        .get("/api/v1/products", {
          params: {
            q: data,
            page: page,
            status: 'active'
          },
        })
        .then((response) => {
          this.paginatedProductsLeft = response.data;
          this.availableProducts = response.data.products;
        });
    },
    searchProductsName(name) {
      this.filter.name = name;

      if (this.nameSearchTimeout) clearTimeout(this.nameSearchTimeout);

      this.nameSearchTimeout = setTimeout(
        () => this.getProducts(),
        500
      );
    },
    searchProductsBrand(brand) {
      this.filter.brand_id = brand ? brand.id : null

      this.getProducts()
    },
    changePage(page) {
      this.getProducts(page);
    },
    getBrands() {
      this.$http.secured
        .get("/api/v1/brands", {
          params: {
            unpaged: true,
          },
        })
        .then((response) => {
          this.availableBrands = response.data;
        });
    },
    updateBrandStructure(name) {
      if (this.commercialBrands.length === 0) {
        this.selectBrandsStructure = [
          {
            origin: "Nova marca",
            brands: name ? [name] : [""]
          },
        ];
      } else {
        this.selectBrandsStructure = [
          {
            origin: "Marcas Existentes",
            brands: this.commercialBrands.map((el) => el.name)
          }
        ];
      }''
    },
    updateProductStructure(name) {
      if (this.preferredProducts.length === 0) {
        this.selectProductsStructure = [
          {
            origin: "Novo Tipo",
            products: [{ id: 'new', name: name}]
          },
        ];
      } else {
        this.selectProductsStructure = [
          {
            origin: "Tipos Existentes",
            products: this.preferredProducts,
          }
        ];
      }
    },
    async getCommercialBrands(query = null, page = 1) {
      const params = { page: page, name_only: true }
      params.q     = { unique_by_name: true }

      if (query) params.q = { name: query, ...params.q };

      this.isLoadingCommercialBrands = true;

      try {
        const response = await this.$http.secured.get(`/api/v2/commercial_brands/`, {
          params: params
        });

        this.commercialBrands = response.data.data;
        this.selectBrandsStructure[1].brands = this.commercialBrands.map((el) => el.name);

      } catch (error) {
        console.log(error);
      } finally {
        this.isLoadingCommercialBrands = false;
      }
    },
    closeModal() {
      this.showModal = false;
      this.resetInputs();
    },
    resetInputs() {
      this.selectProductsStructure[0].products[0].name = "";
      this.selectBrandsStructure[0].brands[0] = "";
      this.baseBrand = null;
      this.availableProducts = [];
      this.selectedProducts = [];
      this.filter = { name: null, brand_id: null };
      this.selectedPreferredProduct = {};
      this.selectedCommercialBrand = "";
    },
    getPageData() {
      this.getProducts();
      this.getCommercialBrands();
      this.getPreferredProducts();
      this.getBrands();
    }
  },
  watch: {
    showModal: function (val) {
      if (!val) return;
      
      this.resetInputs();
      this.getselectedProducts()
      this.setCommercialProductsAttributes()
      this.getPageData()

      if (this.commercialBrand && this.commercialProduct) this.selectedCommercialBrand = this.commercialBrand.name;
      
    },
    commercialProduct: function (val) {
      if (val) {
        this.getselectedProducts()
        this.getProducts()
        return;
      };

      this.selectedProducts = []
    }
  },
  computed: {
    commercialProductPostData: function () {
      const params = {
        commercial_brand_name: this.selectedCommercialBrand,
        commercial_id: this.commercial.id,
        commercial_product: {
          name: this.selectedPreferredProduct.name,
          product_ids: this.selectedProducts.map((el) => {
            return el.id;
          }),
        }
      };
     
      if (this.commercialProduct) {
        params.id = this.commercialProduct.id;
      }
      
      return params;
    },
    showModal: {
      get() {
        return this.show;
      },
      set(modal) {
        this.$emit("update:show", modal);
      },
    },
  },
};
</script>
<style lang="scss">
.tab-pane {
  padding: 10px;
}
.list-picker-selected {
  background: #61cf8a !important;
}
.button-class {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
  margin-bottom: 10px !important;
  padding-left: 10px !important;
  padding-right: 10px !important;
  min-width: 50% !important;
}
.button-class img {
  filter: invert(100%);
}
.list-picker-container {
  border-width: 10px !important;
  border-color: #f6f6f6 !important;
  background-color: #f6f6f6 !important;
  border-radius: 12px !important;
}
.list-picker-panel {
  border: 1px solid;
  border-color: #ccc;
  border-top: 3px solid;
  border-top-color: #61cf8a;
}
.group-title {
  background-color: #61cf8a !important;
  box-sizing: border-box !important;
  color: rgb(255, 255, 255) !important;
  display: inline-block !important;
  font-family: Roboto, sans-serif !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  height: 30px !important;
  line-height: 17px !important;
  padding-bottom: 4px !important;
  padding-left: 12px !important;
  padding-right: 12px !important;
  padding-top: 7px !important;
  text-align: left !important;
  text-size-adjust: 100% !important;
  visibility: visible !important;
  /* width: 35% !important; */
  border-radius: 6px 6px 0px 0px;
  border-bottom: 0px !important;
}
.inputLeft {
  width: 97%;
}
.inputRight {
  float: right;
  width: 89%;
}
#multiselect {
  padding: 0px;
  display: inline;
}

@media (max-width: 768px) {
  .base-pagination-css{
  position: relative;
  margin-top: -630px;
  }
}
</style>
